import httpClient from './index';

const END_POINT = 'notification/to-read';

const readNotification = (ids) => httpClient.put(END_POINT , ids);

export { readNotification };